// @ts-ignore
import { mask, unMask } from "remask";

export function remask(value: any, interfaceMask: any): any {
  return value ? mask(value, interfaceMask) : value;
}

export function unRemask(field: string) {
  return field ? unMask(field) : field;
}
